import React from "react";
import useFetch from "../../utils/useFetch";
import convertToQueryParams from "../../utils/convertToQueryParams";
import useFilters from "../../hooks/useFilters";
import Card from "../card/Card";

function RecentlyLaunched() {
  const Api = `inventory/products/`;

  const {
    filters,
    setFilters,
  } = useFilters({
    ordering: "-created_at",  // Sort by newest first
    is_active: true,
    page: 1,
    size: 10,
    search: null,
    tags: null,

  });

  const { data, loading, error } = useFetch(`${Api}${convertToQueryParams(filters)}`);

  return (
    <div className="lg:py-16 py-10 mx-auto max-w-screen-2xl px-3 sm:px-10">
      <div className="mb-10 flex justify-between items-center">
        <div className="text-left">
          <h2 className="text-xl lg:text-3xl mb-2 text-black font-semibold">
            Recently Launched
          </h2>
          <p className="text-base text-gray-600 leading-6">
            Check out our newest products. Fresh additions to our catalog.
          </p>
        </div>
      </div>

      {loading ? (
        <div className="flex">
          <div className="w-full">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-5 gap-4 md:gap-8 lg:gap-8">
              {[...Array(10)].map((_, index) => (
                <div key={index} className="group box-border overflow-hidden flex rounded-md shadow-sm pr-0 flex-col items-center bg-white relative">
                  <div className="relative flex justify-center w-full h-60 bg-gray-100 animate-pulse">
                    <div className="absolute top-4 right-4 z-10">
                      <div className="p-2 bg-gray-300 rounded-full h-8 w-8"></div>
                    </div>
                  </div>
                  <div className="w-full px-3 lg:px-4 pb-4 overflow-hidden">
                    <div className="relative mb-1 mt-4 space-y-2">
                      <div className="h-4 bg-gray-200 animate-pulse rounded w-3/4"></div>
                      <div className="h-3 bg-gray-200 animate-pulse rounded w-1/2"></div>
                    </div>
                    <div className="flex justify-between items-center mt-2">
                      <div className="h-4 bg-gray-200 animate-pulse rounded w-1/3"></div>
                      <div className="h-8 bg-gray-200 animate-pulse rounded-md w-20"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : error ? (
        <div className="text-center text-red-500">Error: {error.message}</div>
      ) : (
        <div className="flex">
          <div className="w-full">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-5 gap-4 md:gap-8 lg:gap-8">
              {data?.results.map((product, index) => (
                <Card key={index} data={product} />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RecentlyLaunched; 